import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class IdentifyServerPlugin extends SmartenitPlugin {
  // Methods
  public identify(identifyTime: number) {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'Identify',
      {
        IdentifyTime: identifyTime,
      },
      false
    );
  }

  public identifyQuery() {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'IdentifyQuery',
      {},
      false
    );
  }

  public triggerEffect(effectIdentifier: number, effectVariant: number) {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'TriggerEffect',
      {
        EffectIdentifier: effectIdentifier,
        EffectVariant: effectVariant,
      },
      false
    );
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'IdentifyQueryResponse') {
      this._onUpdate.next({ identifyQueryResponse: response.value });
    }
  }
}
